import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tooljet = defineConnector({
  identifier: "tooljet",
  name: "ToolJet",
  tagLine: "Low-code application builder",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.tooljet\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "Basic" },
    ]),
  steps: [
    {
      title: "Enter your ToolJet instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.tooljet.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Enable the external API and set up an access token in your ToolJet instance. See the [API docs](https://docs.tooljet.com/docs/tooljet-api) for details.",
        },
        {
          kind: "input",
          label: "API access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/ext/users`,
  },
});
